// import React from 'react'
// import { Layout } from 'antd'
// import styled from 'styled-components'

// const Header = styled(Layout.Header)`
//   color: white
// `
// export default Header

import React from 'react'
import { Link } from 'react-router-dom'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { Layout, Tag, Menu, /* Dropdown, */ Popover, Icon, Row, Col } from 'antd'
import styled from 'styled-components'
import _get from 'lodash/get'
import can from '~/utils/can'

// import { COLORS } from '../components/styles'
import config from '~/config'
const {
  colors,
  headerHeight
} = config.ui

const HEADER_HEIGHT = `${headerHeight}px`

const Header = styled(Layout.Header)`
  color: white;
  background-color: ${colors.secondary};
  height: ${HEADER_HEIGHT};
  line-height: ${HEADER_HEIGHT};
`

const SiteTitle = styled.div`
  float: left;
`

const PageTitle = styled(Tag)`
  background: white;
  color: '#addc75';
`

const MainMenu = styled(Menu).attrs({
  theme: 'dark',
  mode: 'horizontal',
  selectable: false
})`
  line-height: ${HEADER_HEIGHT};
  float: right;
  background: none;
`

const AppMenu = styled.div`
  width: 180px;
  height: 180px;
`
const AppMenuRow = styled(Row).attrs({
  type: 'flex',
  align: 'middle',
  justify: 'center'
})`
  height: 80px;
  text-align: center;
`

const HeaderNav = compose(
  inject('view'),
  inject('user'),
  observer
)(({ view, user, children }) => (
  <Header>
    <SiteTitle><img src={require('../data/nectecBW.png')} alt='' width='80px'/>  <img src={require('../data/White.png')} alt='' width='35px' vertical-align='text-top'/> <PageTitle>{_get(config, ['app', view.mode, 'title'])}</PageTitle></SiteTitle>
    <MainMenu>
      <Menu.Item key="apps" >
        <Popover
          placement="bottom"
          // trigger={['click']}
          trigger="hover"
          content={
            <AppMenu>
              <AppMenuRow>
                {user.profile && can(user.profile, 'view_monitoring') && <Col span={12}><Link to="/monitoring">Monitor</Link></Col>}
                {user.profile && can(user.profile, 'view_forecasting') && <Col span={12}><Link to="/forecasting">Forecast</Link></Col>}
              </AppMenuRow>
              <AppMenuRow>
                {user.profile && can(user.profile, 'view_scenario') && <Col span={12}><Link to="/scenario">What-if Scenario</Link></Col>}
                {user.profile && can(user.profile, 'view_optimization') && <Col span={12}><Link to="/optimization">Optimize</Link></Col>}
              </AppMenuRow>
            </AppMenu>
          }
        >
          <Icon type="appstore" style={{ fontSize: 24 }} />
        </Popover>
      </Menu.Item>
      <Menu.SubMenu title={<Icon type="user" style={{ fontSize: 24 }} />}>
        <Menu.Item key="setting:1">
          <a href={`${process.env.REACT_APP_GLUU_LOGOUT_URL}`}>Logout</a>
        </Menu.Item>
      </Menu.SubMenu>
    </MainMenu>
  </Header>
))

// <Menu>
//   <Menu.Item key="monitoring"><Link to="/monitoring">Monitoring</Link></Menu.Item>
//   <Menu.Item key="forecasting"><Link to="/forecast">Forcasting</Link></Menu.Item>
//   <Menu.Item key="scenario">Scenario</Menu.Item>
//   <Menu.Item key="optimization">Optimization</Menu.Item>
// </Menu>

// <Menu.Item key="apps" >
//   <Dropdown
//     placement="bottom"
//     //trigger={['click']}
//     trigger="click"
//     content={
//       <Menu>
//         <Menu.Item key="monitoring"><Link to="/monitoring">Monitoring</Link></Menu.Item>
//         <Menu.Item key="forecasting">Forcasting</Menu.Item>
//         <Menu.Item key="scenario">Scenario</Menu.Item>
//         <Menu.Item key="optimization">Optimization</Menu.Item>
//       </Menu>
//     }
//   >
//     <Icon type="appstore" style={{ fontSize: 24 }} />
//   </Dropdown>
// </Menu.Item>

export default HeaderNav



// WEBPACK FOOTER //
// ./src/layout/Header.js